// src/components/WhatsAppFloating.js
import { Box, IconButton, Tooltip, useBreakpointValue } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloating() {
  const whatsappLink =
    "https://chat.whatsapp.com/FjzDctUjecCIEJfTzBMasP?mode=ac_t"; // Replace with your WhatsApp group/channel link

  // Smaller, crisper button on phones — was the same "lg" size on every
  // screen before, which felt oversized and blocky on mobile.
  const buttonSize = useBreakpointValue({ base: "md", md: "lg" });
  const iconSize = useBreakpointValue({ base: 20, md: 26 });
  const offset = useBreakpointValue({ base: "16px", md: "20px" });

  return (
    <Box position="fixed" bottom={offset} right={offset} zIndex="9999">
      <Tooltip label="Join our WhatsApp Group" hasArrow>
        <IconButton
          as="a"
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          icon={<FaWhatsapp size={iconSize} />}
          bg="#25D366" // ✅ Official WhatsApp Green
          color="white"
          borderRadius="full"
          boxShadow="0 4px 14px rgba(37,211,102,0.45)"
          size={buttonSize}
          aria-label="Join WhatsApp Group"
          transition="all 0.18s ease"
          _hover={{
            transform: "scale(1.08)",
            bg: "#1ebe5d",
            boxShadow: "0 6px 18px rgba(37,211,102,0.55)",
          }}
          _active={{ transform: "scale(0.95)" }}
        />
      </Tooltip>
    </Box>
  );
}
